import { createFileRoute } from "@tanstack/react-router";

import LeagueEntries from "@/components/LeagueEntries/LeagueEntries";

const Component = () => {
  const { leagueUuid } = Route.useParams();
  return <LeagueEntries leagueUuid={leagueUuid} />;
};

export const Route = createFileRoute("/gym/$venueUuid/events/series/$leagueUuid/competitors")({
  component: Component,
});
